module.exports = __webpack_public_path__ + "img/business-graphics-1236430-640x640.c42c4fc5.jpg";